export default "__VITE_ASSET__DhTNPm3h__"